/**
 * Sessiya konteksti — joriy foydalanuvchi, roli va biznesi.
 *
 * NIMA UCHUN KONTEKST: rol deyarli har sahifada kerak (NF-303 — ROP ko'radigan
 * tugma menejerda yo'q). Har sahifa `api.me()` ni o'zi chaqirsa, bitta ekran
 * ochilishida uch-to'rt bir xil so'rov ketadi va rol turli sahifalarda turli
 * lahzada yangilanadi.
 *
 * MUHIM: bu kontekst — QULAYLIK, HIMOYA EMAS. Tugmani yashirish ruxsatni
 * tekshirish degani emas; haqiqiy tekshiruv `AuthGuard` (API) va RLS (baza)
 * qatlamlarida (NF-101, NF-303).
 */

import { createContext, useContext } from "react";

import type { SessionUser } from "../api/client";

export interface SessionValue {
  readonly user: SessionUser;
  /** Biznesni almashtirish (PP-1202) — yangi token oladi va sahifani yangilaydi. */
  readonly switchBusiness: (businessId: string) => Promise<void>;
  readonly logout: () => void;
}

const SessionContext = createContext<SessionValue | null>(null);

export const SessionProvider = SessionContext.Provider;

/** Sessiyani o'qiydi. Qobiqdan tashqarida chaqirilsa — dasturchi xatosi. */
export function useSession(): SessionValue {
  const value = useContext(SessionContext);

  if (!value) {
    throw new Error("useSession() faqat Shell ichida ishlaydi");
  }

  return value;
}

/** Rol tekshiruvi — UI ni soddalashtirish uchun (himoya emas). */
export function useHasRole(...roles: readonly string[]): boolean {
  const { user } = useSession();
  return roles.includes(user.role);
}
